import React from "react";
import ItineraryTimesListForm from './list/ItineraryTimesListForm';
import CreateItineraryTimesForm from './create/CreateItineraryTimesForm';

const ItineraryTimesView = ({ displayList }) => {
  return displayList ? (
    <ItineraryTimesListForm />
  ) : (
    <CreateItineraryTimesForm />
  );
};

export default ItineraryTimesView;
